import { render, staticRenderFns } from "./lowPriceNoRealTimeOperate.vue?vue&type=template&id=c389c06a&scoped=true"
import script from "./lowPriceNoRealTimeOperate.vue?vue&type=script&lang=js"
export * from "./lowPriceNoRealTimeOperate.vue?vue&type=script&lang=js"
import style0 from "./lowPriceNoRealTimeOperate.vue?vue&type=style&index=0&id=c389c06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c389c06a",
  null
  
)

export default component.exports